<div *ngIf="_allowAddMode" [hidden]="loading" class="content grid-1-auto md3-surface">
  <div class="content">
    <div class="layout-auto-1">
      <div class="md3-card-on-surface">
        <div class="grid-1-auto typo-small">
          <div class="spawn">
            <button class="md-btn"
                    [class.disabled]="(Message.msgEmpfaengerTo.length + Message.msgEmpfaengerBcc.length + Message.msgEmpfaengerCc.length) === 0
                                      || Message.msgBetreff.length === 0"
                    (click)="send()">
              {{getResource('ButtonSend')}}
            </button>
            <app-exg-dropdown [list]="enumSvc.getEnumerationList('NachrichtTyp')"
                              listdisplay="enmText"
                              [label]="getResource('Type') + ': ' + enumSvc.getEnumerationText('NachrichtTyp',Message.msg_enmIdent_NachrichtTyp)"
                              (change)="changeMessageType($event)">
            </app-exg-dropdown>
            <app-exg-dropdown *ngIf="Message.msg_enmIdent_NachrichtTyp === 2"
                              [list]="enumSvc.getEnumerationList('Postfach')"
                              [adaptiveHeightActive]="true"
                              listdisplay="enmText"
                              [label]="getResource('Postbox') + ': ' + enumSvc.getEnumerationText('Postfach',Message.msg_enmIdent_Postfach)"
                              (change)="changeMessageSender($event)">
            </app-exg-dropdown>
            <app-exg-dropdown [list]="enumSvc.getEnumerationList('NachrichtPrio')"
                              listdisplay="enmText"
                              [label]="getResource('Priority') + ': ' + enumSvc.getEnumerationText('NachrichtPrio',Message.msg_enmIdent_NachrichtPrio)"
                              (change)="changeMessagePriority($event)">
            </app-exg-dropdown>
            <ng-container *ngIf="excSecurity.isFeatured('MSGCATEGORY')">
              <app-exg-dropdown [list]="enumSvc.getEnumerationList('NachrichtKategorie')"
                                listdisplay="enmText"
                                [adaptiveHeightActive]="true"
                                [label]="getResource('Category') + ': ' + enumSvc.getEnumerationText('NachrichtKategorie',Message.msgNachrichtKategorie_enmIdent)"
                                (change)="changeMessageCategory($event)">
              </app-exg-dropdown>
            </ng-container>
          </div>
          <div class="spawn-reverse">
            <!-- 	          <ng-container *ngIf="userType === 1"> -->
            <!-- 		          <exg-checkbox class="md-check-reverse typo-small" [(ngModel)]="Message.msgFIN" [caption]="getResource('FinishCaption')" -->
            <!--                           type="switch"> -->
            <!--               </exg-checkbox> -->
            <!--             </ng-container> -->
            <span class="md-btn" *ngIf="Message.msg_enmIdent_NachrichtTyp === 2"
                  (click)="config.showCc = !config.showCc">{{getResource('Cc')}}
            </span>
            <span class="md-btn" *ngIf="Message.msg_enmIdent_NachrichtTyp === 2"
                  (click)="config.showBcc = !config.showBcc">{{getResource('Bcc')}}
            </span>
          </div>
        </div>
        <div class="typo-container-s-s-q" style="padding:0 0.5rem">
          <span class="md-btn-solid" (click)="selectContacts('msgEmpfaengerTo')">{{getResource('To')}}</span>
          <span><exg-chips listdisplay="kontVal" [list]="Message.msgEmpfaengerTo"
                           (ItemClose)="onContactToChipClose($event)"></exg-chips></span>
          <q></q>
          <ng-container *ngIf="Message.msg_enmIdent_NachrichtTyp === 2 && config.showCc">
              <span class="md-btn-solid"
                    (click)="selectContacts('msgEmpfaengerCc')">{{getResource('Cc')}}</span>
            <span><exg-chips listdisplay="kontVal" [list]="Message.msgEmpfaengerCc"
                             (ItemClose)="onContactCcChipClose($event)"></exg-chips></span>
            <q></q>
          </ng-container>
          <ng-container *ngIf="Message.msg_enmIdent_NachrichtTyp === 2 && config.showBcc">
            <span class="md-btn-solid"
                  (click)="selectContacts('msgEmpfaengerBcc')">{{getResource('Bcc')}}</span>
            <span><exg-chips listdisplay="kontVal" [list]="Message.msgEmpfaengerBcc"
                             (ItemClose)="onContactBccChipClose($event)"></exg-chips></span>
            <q></q>
          </ng-container>

        </div>
        <exg-input [(ngModel)]="Message.msgBetreff" [caption]="enumSvc.getFieldCaption('Nachricht','msgBetreff')"></exg-input>
        <div *ngIf="config.attachmentJagTable.selected.length > 0 || Message.msgAttachmentList.length > 0"
             class="typo-container-s-s-q" style="padding:0 0.5rem">
          <span>{{getResource('Attachments.HeaderText')}}</span>
          <span>
            <exg-chips listdisplay="dokName" [list]="config.attachmentJagTable.selectedObjects"
                       (ItemClose)="onAttachmentChipClose($event)"></exg-chips>
            <exg-chips listdisplay="dokName" [list]="selectedFilesHelper"
                       (ItemClose)="onAttachmentFileChipClose($event)"></exg-chips>
          </span>
        </div>
      </div>
      <div class="md3-card-on-surface app-space-top">
        <editor *ngIf="MCEinit" class="content app-border-none-tiny"
                [(ngModel)]="Message.msgText"
                [init]="MCEinit">
        </editor>
      </div>
    </div>
    <div class="drawer-container right app-table-drawer">
      <div [ngClass]="{'visible': rightDrawerVisible }"
           class="drawer-content md3-card-on-surface app-space-right_0">
        <div class="content width-500 ">
          <app-exg-tab-v2 #VCrightTabControl [header]="rightTabs">
            <ng-template #pages>
              <div class="content app-space-left">
                <!--Vorgang-->
                <div class="app-space-right">
                  <app-drawer-case-details [data]="CaseSummary.caseDetails.data"
                                           [oeList]="CaseSummary.oeList.data"
                                           [Schadenort]="CaseSummary.Schadenort.data">
                  </app-drawer-case-details>
                </div>
                <!--Vorgang-->
                <!-- Auftrag-->
                <div class="app-space-right search-filter-seperator">
                  <app-drawer-case-details
                    [data]="CaseSummary.caseDetails.data"
                    [oeList]="CaseSummary.oeList.data"
                    [Schadenort]="CaseSummary.Schadenort.data">
                  </app-drawer-case-details>
                </div>
                <!--Auftrag-->
              </div>
            </ng-template>
          </app-exg-tab-v2>
        </div>
      </div>
    </div>
  </div>
  <div class="app-drawer md3-card-on-surface">
    <i (click)="rightDrawerVisible = !rightDrawerVisible"
       class="search-filter-action fal fa-info">
    </i>
    <i class="search-filter-seperator"></i>
    <i (click)="appSvc.Case.Workspace.OpenTabV2(CaseSummary.ID)"
	     class="search-filter-action fal fa-folder">
	  </i>
    <i class="search-filter-seperator"></i>
    <i (click)="openAttachmentMgmt()"
       class="search-filter-action fal fa-paperclip">
    </i>
  </div>
</div>
<ng-container *ngIf="loading">
  <div class="splash loading">
    <div><ng-container *ngIf="Data.dmsgID">Standardnachricht wird geladen</ng-container></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</ng-container>


